"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanObject = cleanObject;
exports.cleanArray = cleanArray;
exports.cleanString = exports.reducer = exports.rmTrue = exports.rmEmpty = exports.branch = void 0;

var _trim2 = _interopRequireDefault(require("lodash/fp/trim"));

var _set2 = _interopRequireDefault(require("lodash/fp/set"));

var _reject2 = _interopRequireDefault(require("lodash/fp/reject"));

var _reduce2 = _interopRequireDefault(require("lodash/fp/reduce"));

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _isUndefined2 = _interopRequireDefault(require("lodash/fp/isUndefined"));

var _isEmpty2 = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

var _curry2 = _interopRequireDefault(require("lodash/fp/curry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var transform = _reduce2["default"].convert({
  cap: false
}); // Return undefined if result is empty.


var branch = (0, _curry2["default"])(function (boolCheck, transformer, item) {
  var res = transformer(item);
  return boolCheck(res) ? undefined : res;
});
exports.branch = branch;
var rmEmpty = branch(_isEmpty2["default"]);
exports.rmEmpty = rmEmpty;
var rmTrue = (0, _curry2["default"])(function (transformer, item) {
  return transformer(item) ? undefined : item;
}); // Build up a new so fresh, so clean object.

exports.rmTrue = rmTrue;

var reducer = function reducer(clean) {
  return function (result, value, key) {
    var cleanValue = clean(value, clean);
    return (0, _isUndefined2["default"])(cleanValue) ? result : (0, _set2["default"])([key], cleanValue, result);
  };
}; // Assume we have a fairly normal data object here?


exports.reducer = reducer;

function cleanObject(obj, clean) {
  return transform(reducer(clean), undefined, obj);
}

var cleanString = rmEmpty(_trim2["default"]);
exports.cleanString = cleanString;

function cleanArray(items, clean) {
  var cleanItems = (0, _flow2["default"])((0, _map2["default"])(function (x) {
    return clean(x, clean);
  }), (0, _reject2["default"])(_isUndefined2["default"]));
  return rmEmpty(cleanItems, items);
}
/**
 * [isWorthless description]
 * @param {any} value
 * @return {bool} Tells you if value is empty.
 * @example isWorthless({}) // => true
 * @example isWorthless([' ', null]) // => true
 * @example isWorthless(' ') // => true
 * @example isWorthless({ foo: null, bar: 0 }) // => true
 */
// export const isWorthless = overSome([
//   isNull, isFalse, isZero, isEmptyString, isEmptyArray, isEmptyObject,
// ])
// export const rejectWorthless = reject(isWorthless)
// export const cleanObject = omitBy(isWorthless)
// export const clean = condId(
//   [isArray, flow(compact, map(clean))], // eslint-disable-line no-use-before-define
//   [isPlainObject, cleanObject],
//   [isString, cleanString],
// )